import { createAction } from 'redux-act';

const ActionTypes = {

    /** 显示侧边栏 */
    show: createAction('$$/aside/show'),

    /** 隐藏侧边栏 */
    hide: createAction('$$/aside/hide'),
};

export default ActionTypes;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/redux/reducers/aside/ActionTypes.ts